import React from 'react';
import connectImage from '../../assets/icons/connect.svg';
import intl from '../../locale';
import { ErrorOverlay } from '../ErrorOverlay';

interface AuthErrorOverlayProps {
  isLoading: boolean;
  isWebview: boolean;
  onRetry: () => void;
}

export const AuthErrorOverlay: React.FC<AuthErrorOverlayProps> = ({ isLoading, isWebview, onRetry }) => {
  return (
    <ErrorOverlay
      isLoading={isLoading}
      isWebview={isWebview}
      onClick={onRetry}
      image={connectImage}
      title={intl.formatMessage({ id: 'System.AuthErrorTitle' })}
      description={intl.formatMessage({ id: 'System.AuthErrorDescription' })}
      buttonText={intl.formatMessage({ id: 'System.AuthErrorRetry' })}
    />
  );
};

export default ErrorOverlay;
